import React, {useState} from "react";
import {Card, Col, Row} from "antd";
import {Link} from "react-router-dom";
import {UserOutlined} from "@ant-design/icons";
import {
    faBars,
    faChartScatter,
    faProjectDiagram,
    faScalpel,
    faTrashAlt,
    faUsers
} from "@fortawesome/pro-light-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {MainPageCard} from "../components/MainPageCard";




const CardsPage = (props) => {
    const height = 375
    const [entity, setEntity] = useState()

    const name    = props.match.params.name;

    return (<><Row>
        {entity.map(item => <MainPageCard></MainPageCard>)}
        <MainPageCard title={"Регистр ЗНО (Канцер-регистр)"} description={"Реистр пациентов со злокачественными новообразованиями"}
                      link={"/patients"} icon={faUsers} height={height} img={"card_01.jpg"}/>
        <MainPageCard title={"Регистр предраков"} description={"Реистр пациентов с предраковыми заболеваниями и пациентов группы повышенного онкологического риска"}
                      link={"/patients?pre"} icon={faUsers} height={height} img={"card_02.jpg"}/>
        <MainPageCard title={"Регистр скрининга"} description={"Реистр пациентов прошедших скрининг (независимо от результата)"} icon={faUsers}
                      height={height} img={"card_03.jpg"}/>
        <MainPageCard title={"Гематологический регистр"} description={"Реистр пациентов гематологическими и онко-гематологическими заболеваниями"}
                      link={"/patients?pre"} icon={faUsers} height={height} img={"card_04.jpg"}/>
        <MainPageCard title={"Детский канцер-регистр"} description={"Регистр пациентов с ЗНО до 18 лет"}
                      link={"/patients?pre"} icon={faUsers} height={height} img={"card_05.jpg"}/>

    </Row>

    </>)}

export default CardsPage